export default "__VITE_ASSET__CLQCnmG6__"